import request from '@/http/request'
import {
    getStudentPlanLis,
    checkStudentSignPlanExclusive
} from '@/http/api'

export const getBatch = (data) => {
    return request({
        url: getStudentPlanLis,
        data
    })
}

export const checkStudentSignPlanExclusiveAPI = (data) => {
    return request({
        url: checkStudentSignPlanExclusive,
        data
    })
}